(function () {
  'use strict';

  var READY_CLASS = 'section-sticky-overlap--timeline-ready';
  var COVER_ATTR = 'data-sticky-overlap-cover';
  var SCOPE_ATTR = 'data-sticky-overlap-scope';
  var BASE_SCOPE_ATTR = 'data-sticky-overlap-base-scope';
  var SUSPENDED_BODY_CLASS = 'sticky-overlap-suspended';
  var KEYBOARD_BODY_CLASS = 'theme-keyboard-navigation';
  var manualSuspensions = new Set();
  var activeDrawerKeys = new Set();
  var anonymousDrawerIndex = 0;
  var supportsTimeline = Boolean(
    window.CSS &&
    CSS.supports('timeline-scope: --sticky-overlap-test') &&
    CSS.supports('view-timeline-name: --sticky-overlap-test') &&
    CSS.supports('animation-timeline: --sticky-overlap-test')
  );
  var frame = null;
  var activeSetups = [];
  var activeScopes = [];
  var mobileMedia = window.matchMedia('(max-width: 767px)');
  var reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getDrawerKey(drawer) {
    if (!drawer) return 'unknown';
    if (drawer.id) return 'id:' + drawer.id;
    if (!drawer.dataset.stickyOverlapDrawerKey) {
      anonymousDrawerIndex += 1;
      drawer.dataset.stickyOverlapDrawerKey = 'drawer-' + anonymousDrawerIndex;
    }
    return 'anon:' + drawer.dataset.stickyOverlapDrawerKey;
  }

  function syncSuspendedState() {
    document.body.classList.toggle(
      SUSPENDED_BODY_CLASS,
      manualSuspensions.size > 0 || activeDrawerKeys.size > 0
    );
  }

  function setSuspended(suspended, reason) {
    var key = reason || 'manual';
    if (suspended) {
      manualSuspensions.add(key);
    } else {
      manualSuspensions.delete(key);
    }
    syncSuspendedState();
  }

  function setDrawerSuspended(drawer, suspended) {
    var key = getDrawerKey(drawer);
    if (suspended) {
      activeDrawerKeys.add(key);
    } else {
      activeDrawerKeys.delete(key);
    }
    syncSuspendedState();
  }

  function hasAnimation(source) {
    return source.classList.contains('section-sticky-overlap--anim-scale') ||
      source.classList.contains('section-sticky-overlap--anim-fade') ||
      source.classList.contains('section-sticky-overlap--anim-fade-scale') ||
      source.classList.contains('section-sticky-overlap--anim-blur') ||
      source.classList.contains('section-sticky-overlap--anim-blur-scale');
  }

  function isActiveAtCurrentBreakpoint(source) {
    return !mobileMedia.matches || source.classList.contains('section-sticky-overlap--mobile');
  }

  function getAnimationTargets(source) {
    return Array.prototype.filter.call(source.children, function (target) {
      return target.tagName !== 'STYLE' &&
        target.tagName !== 'SCRIPT' &&
        !target.hasAttribute('data-sticky-overlap-ignore');
    });
  }

  function getStickyStartRange(wrapper, cover) {
    var viewportHeight = document.documentElement.clientHeight || window.innerHeight || 0;
    var sourceHeight = wrapper.offsetHeight;
    var coverHeight = cover.offsetHeight;
    var coverRange = viewportHeight + coverHeight;

    if (!viewportHeight || !sourceHeight || !coverRange || sourceHeight >= viewportHeight) return 0;

    /*
     * A short sticky section can expose the next section before any scrolling.
     * Start the cover animation only when the source reaches its sticky top,
     * not when the following section first enters the viewport.
     */
    return Math.min(100, Math.max(0, ((viewportHeight - sourceHeight) / coverRange) * 100));
  }

  function restorePreviousSetup() {
    activeSetups.forEach(function (setup) {
      setup.source.classList.remove(READY_CLASS);
      setup.targets.forEach(function (target) {
        target.style.removeProperty('animation-timeline');
        target.style.removeProperty('animation-range');
      });
      setup.cover.style.removeProperty('view-timeline-name');
      setup.cover.style.removeProperty('view-timeline-axis');
      setup.cover.removeAttribute(COVER_ATTR);
    });

    activeScopes.forEach(function (scope) {
      var baseScope = scope.getAttribute(BASE_SCOPE_ATTR) || '';
      if (baseScope) {
        scope.style.setProperty('timeline-scope', baseScope);
      } else {
        scope.style.removeProperty('timeline-scope');
      }
      scope.removeAttribute(SCOPE_ATTR);
    });

    activeSetups = [];
    activeScopes = [];
  }

  function refresh() {
    frame = null;
    restorePreviousSetup();

    if (!supportsTimeline || reducedMotionMedia.matches || document.body.classList.contains('theme-design-mode')) return;

    var parentNames = new Map();
    var setups = [];

    document.querySelectorAll('.section-sticky-overlap').forEach(function (source, index) {
      if (!hasAnimation(source) || !isActiveAtCurrentBreakpoint(source)) return;

      var wrapper = source.closest('.shopify-section');
      var cover = wrapper && wrapper.nextElementSibling;
      var parent = wrapper && wrapper.parentElement;
      if (!cover || !cover.classList.contains('shopify-section') || !parent) return;

      var timelineName = '--sticky-overlap-' + index;
      setups.push({
        source: source,
        wrapper: wrapper,
        cover: cover,
        timelineName: timelineName,
        targets: getAnimationTargets(source),
        stickyStartRange: 0
      });

      if (!parentNames.has(parent)) parentNames.set(parent, []);
      parentNames.get(parent).push(timelineName);
    });

    /* Read all geometry before any timeline styles invalidate layout. */
    setups.forEach(function (setup) {
      setup.stickyStartRange = getStickyStartRange(setup.wrapper, setup.cover);
    });

    setups.forEach(function (setup) {
      var source = setup.source;
      var cover = setup.cover;
      cover.style.setProperty('view-timeline-name', setup.timelineName);
      cover.style.setProperty('view-timeline-axis', 'block');
      cover.setAttribute(COVER_ATTR, '');

      setup.targets.forEach(function (target) {
        target.style.setProperty('animation-timeline', setup.timelineName);
        target.style.setProperty('animation-range', 'cover ' + setup.stickyStartRange + '% cover 100%');
      });
      source.classList.add(READY_CLASS);
    });

    parentNames.forEach(function (names, parent) {
      if (!parent.hasAttribute(BASE_SCOPE_ATTR)) {
        parent.setAttribute(BASE_SCOPE_ATTR, parent.style.getPropertyValue('timeline-scope') || '');
      }

      var baseScope = parent.getAttribute(BASE_SCOPE_ATTR);
      var timelineScope = names.join(', ');
      if (baseScope) timelineScope = baseScope + ', ' + timelineScope;
      parent.style.setProperty('timeline-scope', timelineScope);
      parent.setAttribute(SCOPE_ATTR, '');
      activeScopes.push(parent);
    });

    activeSetups = setups;
  }

  function requestRefresh() {
    if (frame) return;
    frame = window.requestAnimationFrame(refresh);
  }

  window.AxiomStickyOverlap = {
    refresh: requestRefresh,
    setSuspended: setSuspended
  };

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || document.body.classList.contains(KEYBOARD_BODY_CLASS)) return;
    document.body.classList.add(KEYBOARD_BODY_CLASS);
    document.dispatchEvent(new CustomEvent('theme:keyboard-navigation-change', {
      detail: { active: true }
    }));
  }, true);

  document.addEventListener('pointerdown', function () {
    if (!document.body.classList.contains(KEYBOARD_BODY_CLASS)) return;
    document.body.classList.remove(KEYBOARD_BODY_CLASS);
    document.dispatchEvent(new CustomEvent('theme:keyboard-navigation-change', {
      detail: { active: false }
    }));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestRefresh, { once: true });
  } else {
    requestRefresh();
  }

  document.addEventListener('shopify:section:load', requestRefresh);
  document.addEventListener('shopify:section:unload', requestRefresh);
  document.addEventListener('shopify:section:reorder', requestRefresh);
  document.addEventListener('theme:resize', requestRefresh);
  document.addEventListener('theme:drawer:open', function (event) {
    setDrawerSuspended(event.detail && event.detail.drawer, true);
  });
  document.addEventListener('theme:drawer:close', function (event) {
    setDrawerSuspended(event.detail && event.detail.drawer, false);
  });
  window.addEventListener('resize', requestRefresh, { passive: true });
})();
